import { GET_PRODUCT } from '../../constants/actions/product';

export function getProduct(payload) {
    return {
        type: GET_PRODUCT,
        payload,
    };
}
